<ng-container *transloco="let t; read: 'time-entries'" >
    <kendo-grid
  [data]="timeEntries"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [skip]="gridState.skip"
  [pageSize]="gridState.pageSize"
  [pageable]="true"
  (pageChange)="onPageChange($event)"
  scrollable="none"
>
  <ng-template kendoGridToolbarTemplate *ngIf="isAdminView">
    <button
      *ngIf="canAdd"
      kendoGridAddCommand
      [disabled]="!isEditable"
    >{{ t('add') }}</button>
  </ng-template>

  <kendo-grid-column
   media="(min-width: 450px)"
   field="employee"
   [title]="t('employee')"
   editable="false"
   *ngIf="!isDayReportView"
  >
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ (dataItem.employeeId | employee | async) }}
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
      let-isNew="isNew"
    >
      <kendo-formfield>
        <kendo-dropdownlist
          [data]="employees$ | async"
          textField="lastName"
          valueField="id"
          [valuePrimitive]="false"
          [formControl]="formGroup.get('employee')"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem.firstName }} {{ dataItem.lastName }}
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem?.firstName }} {{ dataItem?.lastName }}
          </ng-template>
        </kendo-dropdownlist>
        <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column
    media="(min-width: 450px)"
    field="date"
    [title]="t('date')"
    width="150"
    *ngIf="!isDayReportView"
  >
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.date | date: "dd.MM.yyyy" }}
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
      let-isNew="isNew"
    >
      <kendo-formfield>
        <kendo-datepicker
          [formControl]="formGroup.get('date')"
        ></kendo-datepicker>
        <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
    </ng-template>

    <ng-template
      kendoGridFooterTemplate
      let-column
      let-dataItem
      *ngIf="hasGrandTotal"
    >
      <div>Total Seite</div>
      <div>Total Auswahl</div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 450px)"  field="start" [title]="t('start')" width="100">
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-maskedtextbox
        [value]="dataItem.start"
        [mask]="mask"
        [readonly]="true"
      >
      </kendo-maskedtextbox>
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
    >
    <kendo-formfield>
      <kendo-maskedtextbox
        [formControl]="formGroup.get('start')"
        [mask]="editMask"
        [includeLiterals]="true"
        [rules]="maskRules"
      >
      </kendo-maskedtextbox>
      <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
    </kendo-formfield>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 450px)"  field="stop" [title]="t('stop')" width="100">
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-maskedtextbox
        [value]="dataItem.stop"
        [mask]="mask"
        [readonly]="true"
        [style.border-color]="dataItem.stop ? 'rgba(0, 0, 0, 0.08)' : '#d51923'"
      >
      </kendo-maskedtextbox>
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
    >
      <kendo-formfield>
        <kendo-maskedtextbox
          [formControl]="formGroup.get('stop')"
          [mask]="editMask"
          [includeLiterals]="true"
          [rules]="maskRules"
        >
        </kendo-maskedtextbox>

        <kendo-formerror
          *ngIf="formGroup.get('stop').hasError('required') ||
          formGroup.get('stop').hasError('isEmpty')"
        >{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formerror
        *ngIf="startIsLargerThanStop"
      >{{t('startIsLargerThanStop')}}</kendo-formerror>

    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 450px)"  field="duration" [title]="t('duration')" width="100">


    <ng-template
      kendoGridFooterTemplate
      let-column
      let-dataItem
      *ngIf="totalTimeObj || grandTotalTimeObj"
    >
      <ng-container *ngIf="hasGrandTotal">
        <div *ngIf="totalTimeObj">{{ totalTimeObj.toStringShort() }}</div>
        <div>{{ grandTotalTimeObj.toStringShort() }}</div>
      </ng-container>
      <span *ngIf="!hasGrandTotal">
        Total: {{ totalTimeObj.toStringShort() }}
      </span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 450px)"  field="timeEntryCategories" [title]="t('activity')">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.timeEntryCategory?.name ?? "-" }}
    </ng-template>

    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
    >
      <kendo-formfield>
        <kendo-dropdownlist
          [data]="timeEntryCategories"
          textField="name"
          valueField="id"
          [valuePrimitive]="false"
          [formControl]="formGroup.get('timeEntryCategory')"
        >
        </kendo-dropdownlist>
        <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
    </ng-template>
  </kendo-grid-column>

  <ng-container *permissionIf="'Permissions.Assignments.Search'">
    <kendo-grid-column
      field="assignment"
      [title]="t('assignment')"
      media="(min-width: 450px)"
      [hidden]="assignment"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="!dataItem.assignment?.title">
          -
        </ng-container>
        <ng-container *ngIf="dataItem.assignment?.title">
          <a [routerLink]="['/assignment', dataItem.assignment?.id]">
            {{dataItem.assignment?.internalNumber ? dataItem.assignment?.title + " | " + dataItem.assignment?.internalNumber : dataItem.assignment?.title}}
          </a>
        </ng-container>
      </ng-template>

      <ng-template
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup">

        <app-assignment-combobox
          [formControl]="formGroup.get('assignment')"
          [valuePrimitive]="false"
          [hideLink]="true"
        ></app-assignment-combobox>

      </ng-template>
    </kendo-grid-column>
  </ng-container>

  <ng-container *permissionIf="'Permissions.AssignmentServices.Search'">
  <kendo-grid-column
    field="assignmentService"
    [title]="t('service')"
    media="(min-width: 450px)"
  >
    <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.assignmentService?.remarks ? dataItem.assignmentService?.remarks : "-"}}
    </ng-template>

    <ng-template
    kendoGridEditTemplate
    let-dataItem="dataItem"
    let-formGroup="formGroup"
    >
      <kendo-dropdownlist
          *ngIf="formGroup.get('assignment').value?.assignmentServices"
          [data]="formGroup.get('assignment').value?.assignmentServices"
          textField="remarks"
          valueField="id"
          [valuePrimitive]="false"
          [formControl]="formGroup.get('assignmentService')"
          [defaultItem]="defaultItem"
      >
      </kendo-dropdownlist>
    </ng-template>
  </kendo-grid-column>
  </ng-container>

  <kendo-grid-column
    field="confirmedOn"
    [title]="t('confirmedOn')"
    media="(min-width: 450px)"
  >
    <ng-template kendoGridCellTemplate let-dataItem>
      <ng-container *ngIf="dataItem.confirmedOn">
        {{dataItem.confirmedOn | date: "dd.MM.yyyy"}}
      </ng-container>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column
    field="info"
    [title]="t('info')"
    media="(min-width: 450px)"
  >
    <ng-template kendoGridCellTemplate  let-isNew="isNew" let-dataItem>
      <ng-container *ngIf="!isNew">
        <app-change-history
          [createdBy]="dataItem.createdBy"
          [createdOn]="dataItem.createdOn"
          [lastModifiedBy]="dataItem.lastModifiedBy"
          [lastModifiedOn]="dataItem.lastModifiedOn">
        </app-change-history>
      </ng-container>
    </ng-template>
  </kendo-grid-column>


  <kendo-grid-command-column
    media="(min-width: 450px)"
    [title]="t('action')"
    width="250"
    *ngIf="isAdminView"
  >

    <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
      <ng-container *ngIf="!dataItem.signedById">
        <button kendoGridEditCommand themeColor="primary" *ngIf="canEdit(dataItem)">{{ t('edit') }}</button>
        <button kendoGridRemoveCommand *ngIf="canRemove(dataItem)">{{ t('remove') }}</button>
        <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
          {{ isNew ? t('add') : t('save') }}
        </button>
        <button kendoGridCancelCommand>
          {{ isNew ? t('discard') : t('cancel') }}
        </button>
      </ng-container>

      <ng-container *ngIf="dataItem.signedById">
        <p>{{ t('signedBy') + ": " + dataItem.signedBy?.firstName + " " + dataItem.signedBy?.lastName}}</p>
        <p>{{ t('signedOn') + ": " + (dataItem.signedOn | date: "dd.MM.yyyy")}}</p>
      </ng-container>
    </ng-template>


  </kendo-grid-command-column>

  <!-- Mobile View -->
  <kendo-grid-column media="(max-width: 450px)" [title]="t('entries')">
    <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
      <!-- template for mobile -->
       <div class="grid col2 mbs">

        <kendo-formfield *ngIf="!isDayReportView">
        <label>{{ t('employee') }}</label>
          {{dataItem.employee.firstName + " " + dataItem.employee.lastName}}
        </kendo-formfield>

        <kendo-formfield>
          <label>{{ t('date') }}</label>
          {{dataItem.date | date:'dd.MM.yyyy'}}
        </kendo-formfield>

        <kendo-formfield>
          <label>{{ t('start') }}</label>
          <kendo-maskedtextbox
            [value]="dataItem.start"
            [mask]="mask"
            [readonly]="true"
          >
          </kendo-maskedtextbox>
        </kendo-formfield>

        <kendo-formfield>
          <label>{{ t('stop') }}</label>
          <kendo-maskedtextbox
            [value]="dataItem.stop"
            [mask]="mask"
            [readonly]="true"
          >
          </kendo-maskedtextbox>
        </kendo-formfield>

        <kendo-formfield>
          <label>{{ t('duration') }}</label>
          {{dataItem.duration}}
        </kendo-formfield>

        <kendo-formfield>
          <label>{{ t('activity') }}</label>
          {{dataItem.timeEntryCategory?.name ?? "-"}}
        </kendo-formfield>

        <kendo-formfield>
          <label>{{ t('assignment') }}</label>
          <ng-container *ngIf="!dataItem.assignment?.title">
            -
          </ng-container>
          <ng-container *ngIf="dataItem.assignment?.title">
            <a [routerLink]="['/assignment', dataItem.assignment?.id]">
              {{dataItem.assignment?.internalNumber ? dataItem.assignment?.title + " | " + dataItem.assignment?.internalNumber : dataItem.assignment?.title}}
            </a>
      </ng-container>
        </kendo-formfield>

        <kendo-formfield>
          <label>{{ t('service') }}</label>
          {{dataItem.assignmentService?.remarks ? dataItem.assignmentService?.remarks : "-"}}
        </kendo-formfield>
       </div>

       @if(isAdminView){
        <ng-container *ngIf="!dataItem.signedById">
          <button kendoGridEditCommand themeColor="primary" *ngIf="canEdit(dataItem)">{{ t('edit') }}</button>
          <button kendoGridRemoveCommand *ngIf="canRemove(dataItem)">{{ t('remove') }}</button>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
            {{ isNew ? t('add') : t('save') }}
          </button>
          <button kendoGridCancelCommand>
            {{ isNew ? t('discard') : t('cancel') }}
          </button>
        </ng-container>
       }

    </ng-template>

    <!-- Edit Mode -->
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
      let-isNew="isNew"
    >
    <div class="grid col2">

    
      <!-- Mitarbeiter -->
      <kendo-formfield *ngIf="!isDayReportView">
        <label>{{ t('employee') }}</label>
        <kendo-dropdownlist
          [data]="employees$ | async"
          textField="lastName"
          valueField="id"
          [valuePrimitive]="false"
          [formControl]="formGroup.get('employee')"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            {{ dataItem.firstName }} {{ dataItem.lastName }}
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            {{ dataItem?.firstName }} {{ dataItem?.lastName }}
          </ng-template>
        </kendo-dropdownlist>
        <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <!-- Datum -->
      <kendo-formfield>
        <label>{{ t('date') }}</label>
        <kendo-datepicker
          [formControl]="formGroup.get('date')"
        ></kendo-datepicker>
        <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <!-- Start -->
      <kendo-formfield>
        <label>{{ t('start') }}</label>
        <kendo-maskedtextbox
          [formControl]="formGroup.get('start')"
          [mask]="editMask"
          [includeLiterals]="true"
          [rules]="maskRules"
        >
        </kendo-maskedtextbox>
        <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>

      <!-- Stop -->
      <kendo-formfield>
        <label>{{ t('stop') }}</label>
        <kendo-maskedtextbox
          [formControl]="formGroup.get('stop')"
          [mask]="editMask"
          [includeLiterals]="true"
          [rules]="maskRules"
        >
        </kendo-maskedtextbox>

        <kendo-formerror
          *ngIf="formGroup.get('stop').hasError('required') ||
          formGroup.get('stop').hasError('isEmpty')"
        >{{t('isRequiredField')}}</kendo-formerror>
        <kendo-formerror
        *ngIf="startIsLargerThanStop"
        >{{t('startIsLargerThanStop')}}</kendo-formerror>
      </kendo-formfield>



      <!-- Tätigkeit -->
      <kendo-formfield>
        <label>{{ t('activity') }}</label>
        <kendo-dropdownlist
          [data]="timeEntryCategories"
          textField="name"
          valueField="id"
          [valuePrimitive]="false"
          [formControl]="formGroup.get('timeEntryCategory')"
        >
        </kendo-dropdownlist>
        <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>


      <div>
        <label>{{ t('assignment') }}</label>
        <app-assignment-combobox
          [formControl]="formGroup.get('assignment')"
          [valuePrimitive]="false"
          [hideLink]="true"
        ></app-assignment-combobox>
      </div>


      <kendo-formfield *ngIf="formGroup.get('assignment').value?.assignmentServices">
        <label>{{ t('service') }}</label>
        <kendo-dropdownlist
          [data]="formGroup.get('assignment').value?.assignmentServices"
          textField="remarks"
          valueField="id"
          [valuePrimitive]="false"
          [formControl]="formGroup.get('assignmentService')"
          [defaultItem]="defaultItem"
        >
        </kendo-dropdownlist>
      </kendo-formfield>

      <button kendoGridSaveCommand [disabled]="formGroup?.invalid" class="firstRowPos">
            {{ isNew ? t('add') : t('save') }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? t('discard') : t('cancel') }}
      </button>
    </div>






    </ng-template>
  </kendo-grid-column>

  <ng-template
    let-totalPages="totalPages"
    let-currentPage="currentPage"
    kendoPagerTemplate
  >
    <div class="flex flexDirRow">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons
        [buttonCount]="5"
      ></kendo-pager-numeric-buttons>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
    </div>
    <div>
      <label for="pageBtnGroup" class="mrs">{{ t('resultsPerPage') }}</label>
      <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
        <button
          (click)="onPageSizeChange(pageSizes.Small)"
          kendoButton
          [selected]="gridState.pageSize === pageSizes.Small"
          [toggleable]="true"
        >
          {{ pageSizes.Small }}
        </button>
        <button
          (click)="onPageSizeChange(pageSizes.Medium)"
          kendoButton
          [selected]="gridState.pageSize === pageSizes.Medium"
          [toggleable]="true"
        >
          {{ pageSizes.Medium }}
        </button>
        <button
          (click)="onPageSizeChange(pageSizes.Large)"
          kendoButton
          [selected]="gridState.pageSize === pageSizes.Large"
          [toggleable]="true"
        >
          {{ pageSizes.Large }}
        </button>
      </kendo-buttongroup>

      <button
        kendoButton
        [title]="t('refresh')"
        (click)="onGridReload()"
        icon="reload"
      ></button>
    </div>
  </ng-template>
  <ng-template kendoGridNoRecordsTemplate>
    <div class="text pl">{{ t('noResults') }}</div>
  </ng-template>


</kendo-grid>
</ng-container>